module.exports = __webpack_public_path__ + "static/envelope-body-0a6a9a0a45fea5dbe6e5bc1c2a4b996c.webp";